import { motion } from 'framer-motion'
import * as React from 'react'

import { renderBoldSegments } from '../renderBoldSegments'

interface ScanningTurnProps {
  text: string
}

function TypingDots() {
  return (
    <span className="ml-1 inline-flex items-center gap-0.5 align-middle">
      {[0, 1, 2].map((i) => (
        <motion.span
          key={i}
          className="h-1 w-1 rounded-full bg-text-muted"
          animate={{ opacity: [0.3, 1, 0.3] }}
          transition={{ duration: 1, repeat: Infinity, delay: i * 0.18 }}
        />
      ))}
    </span>
  )
}

export function ScanningTurn({ text }: ScanningTurnProps) {
  return (
    <p className="text-sm text-text-muted">
      {renderBoldSegments(text)}
      <TypingDots />
    </p>
  )
}
